







































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() userId!: number;

  @Prop() cate!: number;

  dispatchType = "user/balance";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "类型", scopedSlots: { customRender: "cate" } },
    { title: "操作", scopedSlots: { customRender: "type" } },
    { title: "时间", dataIndex: "created_time" },
    { title: "金额", scopedSlots: { customRender: "money" } },
    { title: "描述", dataIndex: "content" }
  ];

  mounted() {
    this.loadData(
      {
        user_id: this.userId,
        cate: this.cate
      },
      false
    );
  }
}
